import React from 'react';
import { RadioTower } from 'lucide-react';
import { connectionLabel, connectionTone } from '../../lib/rcu/catalog/link';
import { TONE_DOT, TONE_TEXT } from '../../lib/rcu/catalog/feedback';
import type { LinkStatus } from '../../stores/rcuLinkStore';

export interface LinkChipProps {
  link: LinkStatus;
  onClick: () => void;
}

/**
 * The console's link state, always in view. Green means acks will arrive, so a
 * technician knows whether a missing reply is the device or the link.
 */
export const LinkChip: React.FC<LinkChipProps> = ({ link, onClick }) => {
  const tone = connectionTone(link.status);

  return (
    <button
      type="button"
      onClick={onClick}
      title={link.detail}
      className="flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm text-white/80 transition-colors hover:border-[#D4A054] hover:text-[#D4A054]"
    >
      <span className={`h-2 w-2 shrink-0 rounded-full ${TONE_DOT[tone]}`} />
      <RadioTower className="h-4 w-4" />
      {connectionLabel(link.status)}
      <span className={`hidden text-xs sm:inline ${TONE_TEXT[tone]}`}>{link.topics.length > 0 ? 'MQTT' : ''}</span>
    </button>
  );
};

export default LinkChip;
